module.exports = __webpack_public_path__ + "static/img/ffb5dd5c1f8bb2ff5a7e6c93a9d47899.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bk_white.png
// module id = +DNQ
// module chunks = 1